import { Button, Form, Input } from 'antd';
import { login, LogInProps } from '../../lib/firebase.ts';
import { useState } from 'react';
import { useAuth } from './AuthContext.tsx';
import { Link } from 'react-router-dom';

export const LoginForm = () => {
  const { error } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async (data: LogInProps) => {
    setIsLoading(true);
    await login(data);
    setIsLoading(false);
  };

  return (
    <Form
      name="login-form"
      labelCol={{ span: 10 }}
      wrapperCol={{ span: 14 }}
      onFinish={handleSignIn}
      onFinishFailed={console.error}
      autoComplete={'off'}
      disabled={isLoading}
    >
      <Form.Item<string>
        label="メールアドレス"
        name="email"
        rules={[{ required: true, message: 'メールアドレスを入力してください' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item<string>
        label="パスワード"
        name="password"
        rules={[{ required: true, message: 'パスワードを入力してください' }]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          offset: 0,
          span: 24,
          sm: { offset: 8, span: 16 },
        }}
      >
        <Button type="primary" htmlType="submit" loading={isLoading}>
          ログイン
        </Button>
      </Form.Item>

      {error && <div style={{ color: 'red' }}>{error}</div>}

      <Link to={'/auth/sign-up'}>新規登録はこちら</Link>
      <br />
      <Link to={'/auth/reset'}>パスワードを忘れた場合はこちら</Link>
    </Form>
  );
};
